module.exports = new Promise(function(resolve) {
    if (typeof window["clinicalApp"] !== "undefined") return resolve(window["clinicalApp"]);
    var resolved = false;
    function done(container) {
      if (resolved) return;
      resolved = true;
      resolve(container);
    }
    var timer = setTimeout(function() {
      console.warn("[MF] Remote clinicalApp at __CLINICAL_REMOTE_URL__ timed out after 3000ms");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    }, 3000);
    var script = document.createElement("script");
    script.src = "__CLINICAL_REMOTE_URL__";
    script.async = true;
    script.onload = function() {
      clearTimeout(timer);
      if (window["clinicalApp"]) {
        done(window["clinicalApp"]);
      } else {
        console.warn("[MF] Remote clinicalApp loaded but container not found");
        done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
      }
    };
    script.onerror = function() {
      clearTimeout(timer);
      console.warn("[MF] Remote clinicalApp at __CLINICAL_REMOTE_URL__ unreachable");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    };
    document.head.appendChild(script);
  });